module.exports = __webpack_public_path__ + "static/media/search.c8d39dd3.svg";